<script>
    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        computed: {
            date() {
                return this.toDateStr(new Date().setDate(new Date().getDate() - 1));
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget dashboard-widget--filter is-flex is-justify-content-center is-align-items-center">
        <span class="is-size-10">{{ `${$store.getters.getText('dashboardWidgetDateDatauntil')} ${date}` }}</span>
    </div>
</template>
